export type LayoutRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

// Pulls a rect that ended up (partially) outside the canvas back inside: the
// size caps at the canvas, the position shifts so the whole rect fits. Used
// on transform end — the resize gesture itself is unbounded (JS-1248).
export const clampRectToCanvas = (
  rect: LayoutRect,
  canvasWidth: number,
  canvasHeight: number
): LayoutRect => {
  const width = Math.min(rect.width, canvasWidth);
  const height = Math.min(rect.height, canvasHeight);
  const x = Math.min(Math.max(rect.x, 0), canvasWidth - width);
  const y = Math.min(Math.max(rect.y, 0), canvasHeight - height);

  return { x, y, width, height };
};
